import React from 'react';
import '../../stylesheets/home/sharedSectionStyles.css';

const EducationPlatformSection = () => {
  return (
    // Cambiamos <section> por <div className="content-card">
    <div className="content-card">
      <h2>Plataforma Educativa</h2>
      <p className="section-subtitle">
        Accede a trainings asincrónicos diseñados para fortalecer tu empleabilidad, estructurar tu emprendimiento o impulsar el crecimiento de tu empresa.
      </p>
      <ul className="feature-list">
        <li>Cursos digitales organizados por ruta.</li>
        <li>Contenidos prácticos y aplicados.</li>
        <li>Acceso flexible y autogestionado.</li>
      </ul>
      <a 
          href="https://comunidad.wirkconsulting.com/" 
          className="cta-button main-blue"
          target="_blank" 
          rel="noopener noreferrer"
        >
          Explorar Formación
        </a>
    </div>
  );
};

export default EducationPlatformSection;